module.exports = __webpack_public_path__ + "img/ty(28).5db3d70c.png";